export default __webpack_public_path__ + "static/media/hht1_ep4_minisitcom_03.2fdbf5b3.png";